import type { OnInit } from '@angular/core';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import { LinkListComponent as UILinkList } from '@valk-nx/components/ui-link-list/src/lib/link-list.component';
import type { LinkListItem as UILinkListItem } from '@valk-nx/components/ui-link-list/src/lib/link-list.interface';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import type { LinkListItem } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

@Component({
	selector: 'sb-link-list',
	templateUrl: './link-list.html',
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [UILinkList, StoryblokDirective],
})
export class LinkListComponent
	extends StoryblokRootDirective
	implements OnInit
{
	@Input() blocks: LinkListItem[] = [];
	@Input() showDivider = true;
	@Input() showIcons = true;
	@Input() useChevron = true;

	listItems: UILinkListItem[] = [];

	ngOnInit() {
		this.listItems = this.blocks.map((item) => {
			const cachedUrl =
				item.url.linktype === 'email'
					? `mailto:${item.url.cached_url}`
					: item.url.cached_url;
			return {
				text: item.text,
				icon: item.icon,
				url: cachedUrl,
				isExternal:
					item.url.linktype !== 'story' ||
					item.url.target === '_blank',
			};
		});
	}
}
